import Component from '@glimmer/component';
import { eq } from 'ember-truth-helpers';
import type Entry from 'garaje/models/entry';
import { reads, notEmpty } from 'macro-decorators';

interface PreRegistrationColumnSignature {
  Args: {
    content: Entry;
  };
  Element: HTMLDivElement;
}

export default class PreRegistrationColumn extends Component<PreRegistrationColumnSignature> {
  @reads('args.content.currentApprovalStatus') status!: Entry['currentApprovalStatus'];
  @notEmpty('args.content.invite.id') hasInvite!: boolean;

  get hasReports(): boolean {
    return Boolean(this.args.content.visitApproval?.preRegistrationRequiredResult);
  }

  <template>
    <div
      class="table-cell border-b align-top px-2 pt-6 text-carbon-50"
      data-test-pre-reg-status
      data-test-pre-reg-status-value={{this.status}}
      ...attributes
    >
      {{#if this.hasInvite}}
        <span class="whitespace-nowrap" data-test-pre-reg>
          <img src="/assets/images/checkmark-small-gray.svg" role="none" alt="" />
          Invited
        </span>
      {{else}}
        <span class="whitespace-nowrap" data-test-not-pre-reg>
          <img src="/assets/images/gray-dash-small.svg" role="none" alt="" />
          Not invited
        </span>
        {{#if this.hasReports}}
          <br />
          {{#if (eq this.status "pending")}}
            <span class="whitespace-nowrap" data-test-pending>
              <img src="/assets/images/gray-dash-small.svg" role="none" alt="" />
              Pending
            </span>
          {{else if (eq this.status "denied")}}
            <span class="whitespace-nowrap" data-test-denied>
              <img src="/assets/images/cross-small-red.svg" role="none" alt="" style="width:10px; height:10px;" />
              Access denied
            </span>
          {{else if (eq this.status "approved")}}
            <span class="whitespace-nowrap" data-test-approved>
              <img src="/assets/images/checkmark-small-gray.svg" role="none" alt="" style="width:11px; height:10px;" />
              Access approved
            </span>
          {{/if}}
        {{/if}}
      {{/if}}
    </div>
  </template>
}
